import { atom } from 'jotai';
import { DEFAULT_SORT_TYPE_IN_LIKE } from '../components/LikeGoods/constants/sortingTypeInLike';

export interface LikeGoodsFilterState {
  /** -1 또는 null이면 '전체' */
  selectedCategorySno: number | null;
  isDeliveryFilterOn: boolean;
  /**
   * 정렬 키 (`sorting_type_in_like` 의 key).
   * 기본값은 첫 옵션 (담은순).
   */
  sortKey: string;
}

export const likeGoodsFilterAtom = atom<LikeGoodsFilterState>({
  selectedCategorySno: null,
  isDeliveryFilterOn: false,
  sortKey: DEFAULT_SORT_TYPE_IN_LIKE.key,
});
